module.exports = __webpack_public_path__ + "img/fondoopacity3.0e89803a.svg";